import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
// Basic Components
import Button from 'screens/components/basic/Button';
import EmailInput from 'screens/components/basic/EmailInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

class POSEmailReceiptDialog extends Component {
    render() {
        const { t } = this.props; 
        return (
            <div>
                {(this.props.show) ?
                    <DialogInput
                        title={<DialogHeaderWithClose text={t('pos.emailReceiptDialog.fillEmail')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                        modal={true}
                        open={this.props.show}
                        autoScrollBodyContent={true}
                        style={{ zIndex: '950' }}
                        actions={[
                            <Button
                                key={2}
                                name="buttonConfirmCashIn"
                                label={t('pos.emailReceiptDialog.fillEmail')}
                                className="btnNewBrandPOS"
                                primary={true}
                                onTouchTap={() => this.props.onComfirm()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h4 className="purpleText">
                                        {t('pos.printReceipt.fillUpCustomerEmail')}
                                    </h4>
                                </div>
                                <div className="col-lg-12">
                                    <EmailInput name={this.props.name + "Email"}
                                        label={t('pos.emailReceiptDialog.emailAddress')}
                                        floatingLabelText={t('pos.emailReceiptDialog.emailAddress')}
                                        hintText={t('pos.emailReceiptDialog.emailAddress')}
                                        maxLength={60}
                                        fullWidth={true} />
                                </div>
                            </div>
                        </div>
                    </DialogInput>
                    : ""}
            </div>
        )
    }
}

function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps() {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSEmailReceiptDialog))